/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, clientID, CompanyID, isEmpty, isSingleSelect } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import PageLoader from "../../Helpers/PageLoader";
var module = "tablemanagement";
var moduleName = "Table";
var modulePath = "/clientpanel/table";
class Form extends Component {
  constructor(props) {
    super(props);
    const oulteID = this.props.location.state?.oulteID || "";
    this.state = {
      oulteID: oulteID,
      editID: this.props.params?.EditID || '',
      pageloading: false,
      clientdata: {
        tableName: "",
        totalTable: "",
        tablePOSID: "",
        tableStatus: "",
        tableQRCode: "",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params: "company_id=" + CompanyID(),
        url: apiUrl + module + "/" + this.state.editID,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.navigate(modulePath, {
            state: { oulteID: this.state.oulteID },
          });
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var tableStatus = result.tableStatus == "A" ? "Active" : "Inactive";
          var status =
            result.tableStatus !== "" && result.tableStatus !== null
              ? {
                  label: tableStatus,
                  value: result.tableStatus,
                }
              : "";

          var clientupdatedata = {
            tableName: result.tableName,
            tablePOSID: result.tablePOSID,
            totalTable: "",
            tableStatus: status,
            tableQRCode: result.tableQRCode,
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid " + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    var postObject = {
      CreatedBy: clientID(),
      CompanyID: CompanyID(),
      tableOutletID: this.state.oulteID,
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      postObject.tableName = postData.tableName;
      postObject.tablePOSID = postData.tablePOSID;
      (postObject.tableStatus = postData?.tableStatus?.value || "A"), (post_url = `${module}/${this.state.editID}`);
      method = "update";
    } else {
      postObject.totalTable = postData.totalTable;
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"outlet"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{this.state.editID !== "" ? "Update" : "Add New"} Table</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <a
                      href={"/"}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.navigate(modulePath, {
                          state: { oulteID: this.state.oulteID },
                        });
                      }}
                    >
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </a>
                  </div>
                </div>
                <Postform
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  editID={this.state.editID}
                  oulteID={this.state.oulteID}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 160,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { tableName, tableStatus, totalTable } = props.fields;
  if (props.editID !== "") {
    return {
      fields: ["tableName", "tableStatus"],

      validations: {
        tableName: [[isEmpty, tableName]],
        tableStatus: [[isSingleSelect, tableStatus]],
      },
    };
  } else {
    return {
      fields: ["totalTable"],
      validations: {
        totalTable: [[isEmpty, totalTable]],
      },
    };
  }
}

class Postform extends Component {
  constructor(props) {
    super(props);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgtableName,
      errMsgStatus,
      errMsgtotalTable = "";

    if (this.props.editID !== "") {
      if ($validation.tableName.error.reason !== undefined) {
        errMsgtableName = $validation.tableName.show && <span className="error">{$validation.tableName.error.reason}</span>;
      }

      if ($validation.tableStatus.error.reason !== undefined) {
        errMsgStatus = $validation.tableStatus.show && <span className="error">{$validation.tableStatus.error.reason}</span>;
      }
    } else {
      if ($validation.totalTable.error.reason !== undefined) {
        errMsgtotalTable = $validation.totalTable.show && <span className="error">{$validation.totalTable.error.reason}</span>;
      }
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 pt-5">
          <div className={`col-md-12`}>
            {this.props.editID !== "" ? (
              <div className="row">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className={errMsgtableName !== "" && errMsgtableName !== false && errMsgtableName !== undefined ? "form-control is-invalid" : "form-control"}
                      name="tableName"
                      value={fields.tableName}
                      {...$field("tableName", (e) => onChange("tableName", e.target.value))}
                    />
                    <label htmlFor="tableName">
                      Table Name <span className="error">*</span>
                    </label>
                    {errMsgtableName}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input type="text" className="form-control" name="tablePOSID" value={fields.tablePOSID} {...$field("tablePOSID", (e) => onChange("tablePOSID", e.target.value))} />
                    <label htmlFor="tablePOSID">
                      Table POS ID <span className="error">*</span>
                    </label>
                  </div>
                </div>

                <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                  <div className="form-floating form-floating-outline custm-select-box mb-4">
                    <Select
                      value={fields.tableStatus}
                      onChange={this.handleSelectChange.bind(this, "tableStatus")}
                      placeholder="Select Status"
                      options={[
                        { value: "A", label: "Active" },
                        { value: "I", label: "Inactive" },
                      ]}
                      isClearable={true}
                    />
                    <label className="select-box-label">
                      Status<span className="error">*</span>
                    </label>
                    {errMsgStatus}
                  </div>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className={errMsgtotalTable !== "" && errMsgtotalTable !== false && errMsgtotalTable !== undefined ? "form-control is-invalid" : "form-control"}
                      name="totalTable"
                      value={fields.totalTable}
                      {...$field("totalTable", (e) => onChange("totalTable", e.target.value))}
                    />
                    <label htmlFor="totalTable">
                      Total Table<span className="error">*</span>
                    </label>
                    {errMsgtotalTable}
                  </div>
                </div>
              </div>
            )}
          </div>
          {fields.tableQRCode !== "" && (
            <div className={`col-md-2`}>
              <a href={fields.tableQRCode} download={`${fields.tableName}.png`} target="_blank">
                <div className="d-flex align-items-center flex-column">
                  <img src={fields.tableQRCode} alt={fields.tableName} style={{ width: "100%" }} />
                  <div className="user-info text-center">
                    <span className="badge bg-label-primary">Download</span>
                  </div>
                </div>
              </a>
            </div>
          )}
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <a
              href={"/"}
              onClick={(e) => {
                e.preventDefault();
                this.props.navigate(modulePath, {
                  state: { oulteID: this.props.oulteID },
                });
              }}
            >
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </a>
          </div>
        </div>
      </form>
    );
  }
}
Postform = validated(validationConfig)(Postform);
